
import Alert from './alert'
// import Project from './project'
import Cropperiod from './cropperiod'
import Device from './device'
import Report from './report'

export default {
    // User

    // Alert
    global_alert:       Alert.global_alert,
    croppperiod_alert:  Alert.croppperiod_alert,
    project_cps_alert:  Alert.project_cps_alert,
    alert_width_works:  Alert.alert_width_works,

    // Project

    // Cropperiod
    cropperiods:        Cropperiod.cropperiods,
    cropperiod_detail:  Cropperiod.cropperiod_detail,
    growth_period:      Cropperiod.growth_period,
    list_crop:          Cropperiod.list_crop,

    // Device
    device_data:        Device.device_data,
    cameraDevice:       Device.cameraDevice,
    cameraPhoto:        Device.cameraPhoto,

    // Report
    Report_Monthly_1_0: Report.monthly_1_0,
}